(() => {
  const cartUrl = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
  const addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-kt6-product-form]');
    if (!form || form.dataset.kt25Submitting === 'true') return;

    event.preventDefault();
    form.dataset.kt25Submitting = 'true';
    const button = form.querySelector('[data-kt6-add]');
    if (button) button.disabled = true;

    try {
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form),
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error('Cart add failed');
      window.location.assign(cartUrl);
    } catch (error) {
      // Native Shopify POST remains the safety fallback if Ajax is blocked.
      form.dataset.kt25Submitting = 'true';
      HTMLFormElement.prototype.submit.call(form);
    }
  });

  // Header/cart links always resolve to Shopify's native cart route.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-kt25-cart-link]');
    if (!link) return;
    event.preventDefault();
    window.location.assign(cartUrl);
  });
})();
